import PropTypes from "prop-types";
import React, { useContext } from "react";

import { classNames } from "@swa-ui/string";

import "../../generated/platforms/scss/vacations-dark-inverse.module.scss";
import "../../generated/platforms/scss/vacations-light-inverse.module.scss";
import "../../generated/platforms/scss/vacations.module.scss";
import { DesignTokensThemeContext, DesignTokensThemeProvider } from "../DesignTokensThemeProvider";

/**
 * Theme for SWA Vacations light inverse styles.
 */

export const VacationsInverseTheme = (props) => {
  const { children } = props;
  const { isDarkMode } = useContext(DesignTokensThemeContext) ?? {};

  return <DesignTokensThemeProvider {...getProps()}>{children}</DesignTokensThemeProvider>;

  function getProps() {
    return {
      className: classNames(
        isDarkMode ? "vacations-dark-inverse-theme" : "vacations-light-inverse-theme",
        "vacations-theme"
      ),
      inverse: true,
      themeName: "vacations",
    };
  }
};

VacationsInverseTheme.propTypes = {
  /** Content that will be rendered within the theme. */
  children: PropTypes.node,
};
